import type { BuildingItem } from "../components/BuildingSearchResults";

export const isValidBuildingItem = (data: unknown): data is BuildingItem => {
  if (!data || typeof data !== "object") {
    return false;
  }

  const item = data as Record<string, unknown>;

  if (typeof item.building_id !== "string" || !item.building_id) {
    return false;
  }

  if (typeof item.name !== "string" || !item.name) {
    return false;
  }

  if (!item.property || typeof item.property !== "object") {
    return false;
  }

  const property = item.property as Record<string, unknown>;
  if (typeof property.id !== "string" || !property.id) {
    return false;
  }

  if (!Array.isArray(property.device_contracts)) {
    return false;
  }

  if (item.address !== undefined && (typeof item.address !== "object" || item.address === null)) {
    return false;
  }

  if (item.eazy_sync !== undefined) {
    if (typeof item.eazy_sync !== "object" || item.eazy_sync === null) {
      return false;
    }
    const eazySync = item.eazy_sync as Record<string, unknown>;
    if (eazySync.status !== undefined && typeof eazySync.status !== "string") {
      return false;
    }
    if (eazySync.management_id !== undefined && typeof eazySync.management_id !== "string") {
      return false;
    }
    if (eazySync.device_serial_id !== undefined && typeof eazySync.device_serial_id !== "string") {
      return false;
    }
  }

  return true;
};
